import { request } from '@/common/services/request';

const PATH = '/api/operations/tenant/expense-exclusion-rules';
const call = async (suffix, options) => (await request(`${PATH}${suffix}`, options)).data;
export const listExpenseExclusions = (organizationId) =>
  call('', { method: 'GET', params: { organizationId } });
export const saveExpenseExclusion = (organizationId, id, data) =>
  call('', {
    method: id ? 'PATCH' : 'POST',
    params: { organizationId, ...(id ? { id } : {}) },
    data,
  });
export const deleteExpenseExclusion = (organizationId, id) =>
  call('', { method: 'DELETE', params: { organizationId, id } });
export const getExpenseExclusionOptions = (organizationId) =>
  call('/options', { method: 'GET', params: { organizationId } });
export const previewExpenseExclusion = (organizationId, data) =>
  call(
    '/preview',
    data === undefined
      ? { method: 'GET', params: { organizationId } }
      : { method: 'POST', params: { organizationId }, data },
  );
export const getExpenseExclusionMatches = (organizationId, eventId) =>
  call('/matches', { method: 'GET', params: { organizationId, eventId } });
